import Common from './Common';
import cache from '../utils/PromiseCache';

export default class Loyalty {
    static fetchBadge(userId, { noCache = false, ttlMs = 20000 } = {}) {
        const key = `Loyalty.fetchBadge:${userId}`;
        const fetcher = () =>
            Common.request(Common.params({ method: 'get', url: `/v1/achievement/${userId}` }));

        const transform = (response) =>
            Array.isArray(response) ? response.find((loyalty) => loyalty?.name === 'loyalty') : undefined;

        return cache.getTransformed(key, { ttlMs, noCache }, fetcher, transform);
    }
}
